import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../../../services/modal-dialogs';
import { GlobalService } from '../../../../services/global.service';
import { ssApiService } from '../../../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { TrainingEvent } from '../../../../models/domain/training.event';
import { SendTestEmailsForTrainingEventRequest } from '../../../../models/ss-api/requests/send.test.emails.for.training.event.request';
import { EmailWindowType } from '../../../../../app/models/domain/email.window.request';
import { TemplateTypes } from '../../../../../app/models/domain/email.template.item';
import { WindowService } from '../../../../../app/services/window-dialogs/window.service';
import { TrainingEmailEventTypes } from '../../../../models/ss-api/requests/training.email.event.types';
import { Router } from '@angular/router';
import { EmailDialog } from '../../../../dialogs/email/email.dialog';

export interface IEditEventEmailsModel {
    title: string;
}

@Component({
    selector: 'edit-event-emails',
    styleUrls: ['./edit.event.emails.css'],
    templateUrl: './edit.event.emails.html'
})

export class EditEventEmails extends DialogComponent<IEditEventEmailsModel, TrainingEvent> implements IEditEventEmailsModel, OnChanges, OnInit {
    @Input('Event') Event: TrainingEvent;
    @Output('SaveEvent') SaveEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

    title: string;
    GoToMeetingLink: string;
    WebinarID: string;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, private windowService: WindowService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.GoToMeetingLink = this.Event.GoToMeetingLink;
        this.WebinarID = this.Event.WebinarID;
    }

    ngOnChanges(changes: SimpleChanges) {
        this.Event = changes.Event.currentValue;
    }

    nameGUID(): string {
        
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });

    }

    sendTestEmail(type: TrainingEmailEventTypes) {
        this.SaveEvent.emit(true);
        this.sweetAlert.swal(
            {
                title: 'Send Test Email',
                input: 'text',            
                inputValue: '',
                inputPlaceholder: 'Email address',
                showCancelButton: true,
                preConfirm: (response) => {
                    let request: SendTestEmailsForTrainingEventRequest = new SendTestEmailsForTrainingEventRequest();
                    request.TrainingEventID = this.Event.ID;
                    request.TrainingEmailEventType = type;
                    request.TestEmails = response.split(';');

                    return this.api.SendTestEmailsForTrainingEvent(request).toPromise();
                }
            }).then((response: any) => {
                this.sweetAlert.swal({
                    title: 'Test Email Sent',
                    text: 'Please check your inbox to see the test email.',
                    type: 'success'
                })
            }, (dismiss) => {
                return;
            }
            );
    }

    sendRealEmail(type: TrainingEmailEventTypes) {
        this.SaveEvent.emit(true);
        setTimeout(() => {
            let disposable = this.dialogService.addDialog(EmailDialog, {
                Type: EmailWindowType.Training,
                Templates: [TemplateTypes.Training],
                TrainingEvent: this.Event,
                TrainingEmailEventType: type
            }, { width: 1140, height: 800 }).subscribe(response => {
                disposable.unsubscribe();
            })
        }, 1000);
    }

    LogForEmail(type: TrainingEmailEventTypes) {
        if (this.Event.EmailLogs) {
            return this.Event.EmailLogs.find(email => email.TrainingEmailEventType == type);
        }
    }

    CheckForLinks(){
        return this.Event.GoToMeetingLink == "" || this.Event.GoToMeetingLink == null || this.Event.WebinarID == null || this.Event.WebinarID == "";
    }

}
